import { render, staticRenderFns } from "./delivery-demand-list.vue?vue&type=template&id=04ad9ae1"
import script from "./delivery-demand-list.vue?vue&type=script&lang=js"
export * from "./delivery-demand-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports